import { Component, Input, OnChanges, ViewChild } from '@angular/core';
import { Font } from '@jump-tools-front/shared-interfaces';

@Component({
  selector: 'shared-fonts-loader',
  templateUrl: './fonts-loader.component.html',
  standalone: true,
})
export class FontsLoaderComponent implements OnChanges {
  @Input() font: Font;
  @ViewChild('receiver', { static: true }) receiver;

  ngOnChanges(): void {
    const styleNode = document.createElement('style');
    styleNode.innerHTML = `@font-face {
      font-family: ${this.font.cssName || this.font.family};
      src: url(${this.font.src})
      }`;
    (this.receiver.nativeElement as HTMLDivElement).appendChild(styleNode);
  }
}
